import uniq from 'lodash/uniq'
import { CALL_API, REQUEST_POST } from '../middleware/api'
import { responses as responsesAPI } from '../utils/api'
import { SUCCESS, ERROR } from '../components/AlertListItem'
import { buildBaseURL } from '../utils/urlHelper'
import { camelizeKeys } from 'humps'
import { createAlert } from './alertActions'
import { normalize } from 'normalizr'
import { RESPONSE, NONE } from '../schemas'

export const CLEAR_RESPONSE = 'tru/CLEAR_RESPONSE'
export const RESPONSE_REQUEST = 'tru/RESPONSE_REQUEST'
export const RESPONSE_SUCCESS = 'tru/RESPONSE_SUCCESS'
export const RESPONSE_FAILURE = 'tru/RESPONSE_FAILURE'
export const TOGGLE_OBSERVERS_VIEW_PII = 'tru/TOGGLE_OBSERVERS_VIEW_PII'
export const ADD_RESPONSE_TO_WORKSPACE_REQUEST =
  'tru/ADD_RESPONSE_TO_WORKSPACE_REQUEST'
export const ADD_RESPONSE_TO_WORKSPACE_SUCCESS =
  'tru/ADD_RESPONSE_TO_WORKSPACE_SUCCESS'
export const ADD_RESPONSE_TO_WORKSPACE_FAILURE =
  'tru/ADD_RESPONSE_TO_WORKSPACE_FAILURE'

const requestResponse = id => ({
  type: RESPONSE_REQUEST,
  id
})

const receiveResponse = (data, { entities }) => ({
  type: RESPONSE_SUCCESS,
  data,
  entities
})

const receiveResponseFailed = errors => ({
  type: RESPONSE_FAILURE,
  errors
})

export const fetchResponse = id => dispatch => {
  dispatch(requestResponse(id))

  return responsesAPI
    .get(id)
    .then(
      ({ data }) =>
        dispatch(
          receiveResponse(camelizeKeys(data), normalize(data, RESPONSE))
        ),
      error => dispatch(receiveResponseFailed(error))
    )
}

export const toggleObserversViewPii = (id, value) => dispatch =>
  responsesAPI
    .toggleObserversViewPiiFlag(id, value)
    .then(() => {
      let message

      if (value) {
        message =
          "Enabled. Observers will be able to view this response's video"
      } else {
        message =
          'Disabled. Observers in this project will only receive audio for ' +
          'this response'
      }

      dispatch({ type: TOGGLE_OBSERVERS_VIEW_PII, id, value })
      dispatch(createAlert({ type: SUCCESS, message }))
    })
    .catch(() => {
      dispatch(
        createAlert({
          type: ERROR,
          message: 'There was a problem updating the response'
        })
      )
    })

export const clearResponse = id => ({
  type: CLEAR_RESPONSE,
  id
})

export const addToWorkspace = (company, response, workspace) => {
  const workspaceURL = buildBaseURL(`workspaces/${workspace.id}`)

  return {
    [ADD_RESPONSE_TO_WORKSPACE_SUCCESS]: {
      entities: {
        responses: {
          [response.id]: {
            workspaces: uniq([
              ...response.workspaces.map(workspace => workspace.id),
              workspace.id
            ])
          }
        }
      },
      alert: {
        type: SUCCESS,
        message:
          `Added to ${workspace.name}.` +
          `<a href="${workspaceURL}">View it now!</a>`,
        htmlSafe: true
      }
    },
    [CALL_API]: {
      types: [
        ADD_RESPONSE_TO_WORKSPACE_REQUEST,
        ADD_RESPONSE_TO_WORKSPACE_SUCCESS,
        ADD_RESPONSE_TO_WORKSPACE_FAILURE
      ],
      // eslint-disable-next-line max-len
      endpoint: `companies/${company.id}/workspaces/${workspace.id}/responses/${response.id}.json`,
      requestType: REQUEST_POST,
      schema: NONE
    }
  }
}



// WEBPACK FOOTER //
// ../src/actions/responseActions.js